import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// import PoolRewardDetailList from '@/component/pool-reward/list';
import { Box, Card, CardContent, Typography } from '@mui/material';
import Header from '@/component/Header';
import PoolRewardDetailSetting from '@/component/pool-reward/setting';
import { readTitle } from '@/api/asset/pool/read';
import PoolRewardDetailList from '@/component/pool-reward/list';

export default function PoolRewardDetail() {
  const {
    state: { rowValue },
  } = useLocation();
  const [title, setTitle] = useState('');
  // useEffect(() => {
  //   console.log(rowValue);
  //   // 풀 아이디로 현재 리워드 세팅 조회
  //   // 리워드 리스트 및 리워드 추가 및 삭제, 수정 버튼 추가
  //   // 해당 날짜(start_dt)되면 ticker, is_possible 업데이트,
  //   return () => {};
  // }, []);

  useEffect(() => {
    if (rowValue.poolId) {
      (async () => {
        const re = await readTitle(rowValue.poolId);
        setTitle(re.data.title);
      })();
    }
    return () => {};
  }, [rowValue.poolId]);

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Box>
        <Card>
          <Header title={`리워드 등록 및 리스트: ${title}`} />
          <CardContent>
            <Typography variant="h6">리워드 등록</Typography>
            <PoolRewardDetailSetting pool_id={rowValue.poolId} />
            <Box mb={10} />
            <Typography variant="h6">리워드 리스트</Typography>
            <PoolRewardDetailList poolId={rowValue.poolId} />
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
